<template>
  <div class="customer-basic" v-loading="isLoading">
    <!-- <div class="title">必填设置</div> -->
    <el-form label-position="left">
      <el-form-item
        v-for="(item, index) in requiredList"
        :key="index"
        class="auto-height"
      >
        <div class="rules-name">{{ item.displayName }}</div>
        <el-checkbox
          v-model="item.value"
          v-if="
            item.value === true ||
            item.value === false ||
            item.value === 'true' ||
            item.value === 'false'
          "
          >{{ item.displayName }}</el-checkbox
        >
        <el-input
          v-else
          v-model="item.value"
          clearable
          :min="0"
          :placeholder="`请输入${item.displayName}`"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <el-button type="primary" @click="changeClaims" :loading="isLoadingSubmit"
        >保存</el-button
      >
      <el-button @click="reduction" :loading="isCloaseLoading">重置</el-button>
    </div>
  </div>
</template>

<script>
import { deepCopy } from "@/utils/deepCopy";
import { getTenantSettings, updateTenantSettings } from "@/http/api/system";
export default {
  props: {
    isEdit: { type: Boolean },
  },
  data() {
    return {
      requiredSetting: [],
      requiredList: [],
      isDisabled: false,
      permissions: this.$store.getters.permissions,
      isCloaseLoading: false,
      isLoadingSubmit: false,
      isLoading:true
    };
  },
  mounted() {
    this.init();
    // this.isDisabled = !this.permissionList["RocketIdentity.Roles.ManagePermissions"];
  },
  methods: {
    reduction() {
      this.isCloaseLoading = true;
      this.init();
      this.isCloaseLoading = false;
    },
    showDisable() {
      if (this.isDisabled) {
        this.$message.warning({
          message: `您暂无修改权限`,
          showClose: true,
        });
      }
    },
    init() {
      this.isLoading = true
      this.requiredList = [];
      getTenantSettings().then((res) => {
        res.result.map((item) => {
          if (!item.isCollection) {
            this.requiredList.push(item);
          }
        });
        setTimeout(()=>{
          this.isLoading = false
        },300)
      });
    },
    cancel() {
      this.init();
    },

    changeSelectedScope(item) {
      if (this.permissions["System.getTenantSettings.Update"]) {
        this.changeClaims(item, item.value);
      } else {
        this.$message.warning({
          message: `您暂无更新租户设置权限`,
          showClose: true,
        });
      }
    },
    changeClaims(setting, selectedScope) {
      let data = [];
      this.requiredList.map((item) => {
        data.push({
          name: item.name,
          value: item.value,
          forceToSet: false,
          isCollection: false,
        });
      });
      let settings = {
        settings: data,
      };
      updateTenantSettings(
        this.$store.getters.generateUpdateSettingsParams,
        settings
      ).then((res) => {
        if (res) {
          this.$message.success({
            message: `修改成功`,
            showClose: true,
          });
        }
        this.init();
        this.isEditSetting = false;
      });
    },
    submit() {
      this.requiredSetting = deepCopy(this.requiredList);
      //console.log("提交接口");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.customer-basic {
  padding: 20px;
  background: #fff;
  .title {
    margin-bottom: 20px;
    font-size: 15px;
  }

  .required-setting {
    margin-bottom: 10px;
    .required-name {
      display: inline-block;
      width: 500px;
    }
  }
  .table-tit,
  .table-info {
    @include flex(row, center);
    background: #f1f1f1;
    .table-val {
      @include flex(row, center);
      justify-content: space-between;
      border-bottom: 1px solid #dfdfdf;
      border-left: 1px solid #dfdfdf;
      padding: 10px 10px;
      width: 50%;
      height: 20px;
      line-height: 20px;
      .table-name {
        width: 85%;
        overflow: hidden;
      }
      .table-operation {
        cursor: pointer;
      }
    }

    .subset {
      padding-left: 12px;
    }
    .table-tips {
      padding: 10px 10px;
      border-left: 1px solid #dfdfdf;
      border-right: 1px solid #dfdfdf;
      border-bottom: 1px solid #dfdfdf;
      width: 50%;
      height: 20px;
      line-height: 20px;
    }
  }
  .table-tit {
    border-top: 1px solid #dfdfdf;
  }
  .table-info {
    background: #fff;
  }
}
</style>